import { Injectable } from '@angular/core';
import { toWords } from 'number-to-words';

@Injectable({
  providedIn: 'root',
})
export class WordConverterService {
  convert(num: number): string {
    // Get the words from the `toWords` function
    if (isNaN(num)) {
      console.log('num is not a number', num);
      return;
    }

    let words = toWords(num).replace(/-/g, ' ');

    // Capitalize the first letter
    words = this.capitalizeFirstLetter(words);

    return words;
  }

  private capitalizeFirstLetter(words: string): string {
    return words
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
